import React, { useEffect } from 'react'
import { ClientListProps } from './ClientList.props'
import Table from 'components/Table'
import { ClientListContainer } from './ClientList.styled'
import { useAppDispatch, useAppState } from 'store'
import ClientListItem from './ClientListItem'
import { clientActions } from 'store/slices/clients/clients.slice'
import { useAmplitude } from 'hooks/useAmplitude'
import { AMPLITUDE_EVENTS } from 'amplitude/events'

const CLIENT_LIST_HEADER: string[] = [
  '',
  'First Name',
  'Last Name',
  'Email',
  'Options',
]
const ClientList = ({ clients, locationId }: ClientListProps) => {
  const dispatch = useAppDispatch()
  const { totalClients, currentPage } = useAppState(state => state.clients)
  const { logEvent } = useAmplitude()

  useEffect(() => {
    logEvent(AMPLITUDE_EVENTS.CLIENT_LIST_PAGE_EVENT, { location: locationId })
  }, [])

  const handlePage = (newPage: number) => {
    dispatch(clientActions.setCurrentPage(newPage))
  }

  return (
    <ClientListContainer>
      <Table
        header={CLIENT_LIST_HEADER}
        pagination
        totalCount={totalClients}
        currentPage={currentPage}
        onChangePage={handlePage}>
        {clients &&
          clients.length > 0 &&
          clients.map(client => (
            <ClientListItem
              key={client.id}
              client={client}
              locationId={locationId}
            />
          ))}
      </Table>
    </ClientListContainer>
  )
}

export default ClientList
